import { module } from 'angular';
import { gmcTooltipDirective } from './gmc-tooltip.directive';

export const GmcTooltipModule = module('app.ui.gmc-tooltip', [])
  .directive('gmcTooltip', gmcTooltipDirective)
  .name;



// WEBPACK FOOTER //
// ./app/ui/gmc-tooltip/gmc-tooltip.module.ts